export default "__VITE_ASSET__DZYasuoe__"